import { render, staticRenderFns } from "./PopOrderDetail.vue?vue&type=template&id=ce3e2ee0&"
import script from "./PopOrderDetail.vue?vue&type=script&lang=js&"
export * from "./PopOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./PopOrderDetail.vue?vue&type=style&index=0&id=ce3e2ee0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports